export class BankIdQrCodeRequestBuilder {
    constructor() {
        this.properties = {};
    }
    static validate(request) {
        if (!request) {
            throw new Error("Request can not be falsy");
        }
        if (!request.orderRef) {
            throw new Error("Missing orderRef");
        }
    }
    withOrderRef(orderRef) {
        this.properties.orderRef = orderRef;
        return this;
    }
    build() {
        return this.properties;
    }
}
